import axios from "axios";

const ADMIN_API = "https://japanichiba.duckdns.org/api/v1/admin/";

export const findAllProduct = async (pageNumber = 0, pageSize = 10) => {
    let result = null;
    try {
        result = await axios.get(`${ADMIN_API}all`, {
            params: { pageNumber, pageSize },
            headers: { }
        });
    } catch (e) {
        console.log("Find products API error: " + e);
    }
    return result?.data;
};

export const deleteProduct = async (ProductId) => {
    try {
        const response = await axios.delete(`${ADMIN_API}${ProductId}`);
        return response.data;
    } catch (error) {
        console.error("Delete movie API error: " + error);
    }
};

// ĐÃ SỬA: Thay thế 'productData' bằng 'formData', truyền Token bảo mật và ép header gửi file Multipart
export const updateProduct = async (id, formData) => {
    let token = localStorage.getItem("token");
    try {
        const result = await axios.put(`${ADMIN_API}product/${id}`, formData, {
            headers: {
                Accept: 'application/json',
                "Content-Type": 'multipart/form-data',
                Authorization: "Bearer " + token
            }
        });
        return result.data;
    } catch (e) {
        console.log("Update product API error: " + e);
        throw e; // BẮT BUỘC THÊM DÒNG NÀY để quăng lỗi ra ngoài cho UI xử lý!
    }
};

export const findProductsByIdAdmin = async (id) => {
    let result = null;
    try {
        result = await axios.get(`${ADMIN_API}product/${id}`, {
            headers: { }
        });
    } catch (e) {
        console.log("Find books API error: " + e);
    }
    return result?.data;
};

export const fetchCreateNewProduct = async (formData) => {
    let token = localStorage.getItem("token");
    try {
        // ĐÃ SỬA: Đổi Content-Type thành multipart/form-data để hỗ trợ truyền file
        await axios.post(`${ADMIN_API}create`, formData, {
            headers: {
                Accept: 'application/json',
                "Content-Type": 'multipart/form-data',
                Authorization: "Bearer " + token
            },
        });
        return true;
    } catch (e) {
        console.log("Create Product API error: " + e);
        return false;
    }
};
